import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';

import { arrayOf, element, oneOfType } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';

import './label.css';

class Label extends PureComponent {
  static propTypes = {
    text: PropTypes.string,
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    uuid: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    text: 'Sample label',
  };

  render() {
    const { text, children, className } = this.props;

    return (
      <div className={className}>
        <label className="c-label">{msg(text)}</label>
        {children}
      </div>
    );
  }
}

export default Label;
